/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Tab_Downgrade_Loss_ApiInputs */



/**
* | output |
* | --- |
* | "API Keys & programmatic access" |
*
* @param {Plan_Tab_Downgrade_Loss_ApiInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_tab_downgrade_loss_api = /** @type {((inputs?: Plan_Tab_Downgrade_Loss_ApiInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Tab_Downgrade_Loss_ApiInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("API-Schlüssel & programmatischer Zugriff")
	return /** @type {LocalizedString} */ ("API Keys & programmatic access")
});